'use strict';

const React = require('react'),
  {t} = require('services/i18nextWrapper'),
  moment = require('moment'),
  SessionStore = require('stores/SessionStore'),
  FontIcon = require('material-ui/lib/font-icon'),
  PositionUtil = require('utils/PositionUtils'),
  {delay} = require('lodash/function'),
  ga = require('react-ga'),
  packageJson = require('../../../package.json');

const Help = React.createClass({displayName: "Help",
  
  componentDidMount() {
    ga.pageview('/help');
  },
  
  goToLink(refName, evt) {
    evt.preventDefault();
    evt.stopPropagation();
    
    delay(() => {
      const scrollTop = PositionUtil.elementScrollTop(this.refs[refName].getDOMNode());
      PositionUtil.scrollTo(scrollTop + (-110));
    }, 350); // timeout to show effect transition return
  },
  
  render: function () {
    return (
      React.createElement("div", {className: 'bp-support-page' + (SessionStore.isFullPaidVersion() ? '' : ' is-free-version')}, 
        React.createElement("div", {className: "bp-support-page__head"}, 
          
          React.createElement("div", {className: "bp-support-page__header"}, 
            React.createElement("h1", {className: "bp-support-page__header-title"}, t('help_title'))
          ), 
          React.createElement("div", {className: "bp-support-page__header-subtitle"}, 
            t('help_subtitle')
          )
        
        ), 
        
        React.createElement("div", {className: "bp-support-page__body"}, 
          React.createElement("div", {className: "bp-support-page__question-content row"}, 
            React.createElement("a", {target: "_blank", href: "http://www.brewplanner.com/videos", 
               className: "bp-support-page__question-box col-md-3 col-sm-4 col-xs-12"}, 
              React.createElement("h1", null, t('help_subtitle_video_tutorials')), 
              React.createElement(FontIcon, {className: "material-icons material-icons--custom"}, "ondemand_video")
            ), 
            React.createElement("a", {target: "_blank", href: "http://www.brewplanner.com/faq", 
               className: "bp-support-page__question-box col-md-3 col-sm-4 col-xs-12"}, 
              React.createElement("h1", null, t('help_frequently_questions')), 
              React.createElement(FontIcon, {className: "material-icons material-icons--custom"}, "ring_volume")
            ), 
            React.createElement("a", {className: "bp-support-page__question-box col-md-3 col-sm-4 col-xs-12", 
               href: "mailto:support@brewplanner.com?Subject=Need%20help", 
               target: "_top"}, 
              React.createElement("h1", null, t('help_contact_us')), 
              React.createElement(FontIcon, {className: "material-icons material-icons--custom"}, "mail_outline")
            ), 
            React.createElement("article", {onClick: this.goToLink.bind(this, 'gettingStarted'), 
                     className: "bp-support-page__question-box col-md-3 col-sm-4 col-xs-12"}, 
              React.createElement("h1", null, t('help_getting_started')), 
              React.createElement(FontIcon, {className: "material-icons material-icons--custom"}, "tag_faces")
            ), 
            React.createElement("article", {onClick: this.goToLink.bind(this, 'tankAndSection'), 
                     className: "bp-support-page__question-box col-md-3 col-sm-4 col-xs-12"}, 
              React.createElement("h1", null, t('help_assign_tanks_sections')), 
              React.createElement(FontIcon, {className: "icon-tanks-page"})
            ), 
            React.createElement("article", {onClick: this.goToLink.bind(this, 'assignBeerStyle'), 
                     className: "bp-support-page__question-box col-md-3 col-sm-4 col-xs-12"}, 
              React.createElement("h1", {className: "bp-support-page__question-box-title"}, t('help_assign_beer_styles')), 
              React.createElement(FontIcon, {className: "icon-beer-style-page"})
            ), 
            React.createElement("article", {onClick: this.goToLink.bind(this, 'settingProcess'), 
                     className: "bp-support-page__question-box col-md-3 col-sm-4 col-xs-12"}, 
              React.createElement("h1", null, t('help_setting_processes')), 
              React.createElement(FontIcon, {className: "material-icons material-icons--custom"}, "settings")
            ), 
            React.createElement("article", {onClick: this.goToLink.bind(this, 'scheduleBrew'), 
                     className: "bp-support-page__question-box col-md-3 col-sm-4 col-xs-12"}, 
              React.createElement("h1", null, t('help_schedule_a_brew')), 
              React.createElement(FontIcon, {className: "material-icons material-icons--custom"}, "watch_later")
            ), 
            React.createElement("article", {onClick: this.goToLink.bind(this, 'batchNumber'), 
                     className: "bp-support-page__question-box col-md-3 col-sm-4 col-xs-12"}, 
              React.createElement("h1", null, t('help_batch_numbers')), 
              React.createElement(FontIcon, {className: "material-icons material-icons--custom"}, "exposure_plus_1")
            ), 
            React.createElement("article", {onClick: this.goToLink.bind(this, 'scenarios'), 
                     className: "bp-support-page__question-box col-md-3 col-sm-4 col-xs-12"}, 
              React.createElement("h1", null, t('help_possible_scenarios')), 
              React.createElement(FontIcon, {className: "material-icons material-icons--custom"}, "developer_board")
            ), 
            React.createElement("article", {onClick: this.goToLink.bind(this, 'iconLabelAndProcess'), 
                     className: "bp-support-page__question-box col-md-3 col-sm-4 col-xs-12"}, 
              React.createElement("h1", null, t('help_icons_labels_processes')), 
              React.createElement(FontIcon, {className: "material-icons material-icons--custom"}, "device_hub")
            ), 
            React.createElement("article", {onClick: this.goToLink.bind(this, 'notes'), 
                     className: "bp-support-page__question-box col-md-3 col-sm-4 col-xs-12"}, 
              React.createElement("h1", null, t('notes')), 
              React.createElement(FontIcon, {className: "material-icons material-icons--custom"}, "note_add")
            ), 
            React.createElement("article", {onClick: this.goToLink.bind(this, 'messages'), 
                     className: "bp-support-page__question-box col-md-3 col-sm-4 col-xs-12"}, 
              React.createElement("h1", null, t('messages')), 
              React.createElement(FontIcon, {className: "material-icons material-icons--custom"}, "sms")
            ), 
            React.createElement("article", {onClick: this.goToLink.bind(this, 'changeOrder'), 
                     className: "bp-support-page__question-box col-md-3 col-sm-4 col-xs-12"}, 
              React.createElement("h1", null, t('help_make_changes_to_an_order')), 
              React.createElement(FontIcon, {className: "material-icons material-icons--custom"}, "mode_edit")
            ), 
            React.createElement("article", {onClick: this.goToLink.bind(this, 'display'), 
                     className: "bp-support-page__question-box col-md-3 col-sm-4 col-xs-12"}, 
              React.createElement("h1", null, t('display')), 
              React.createElement(FontIcon, {className: "material-icons material-icons--custom"}, "tv")
            ), 
            React.createElement("article", {onClick: this.goToLink.bind(this, 'publish'), 
                     className: "bp-support-page__question-box col-md-3 col-sm-4 col-xs-12"}, 
              React.createElement("h1", null, t('publish')), 
              React.createElement(FontIcon, {className: "material-icons material-icons--custom"}, "cloud_upload")
            )
          )
        ), 
        
        React.createElement("hr", {className: "bp-support-page__separator"}), 
        
        React.createElement("div", {className: "bp-support-page__comment"}, 
          React.createElement("h2", {ref: "gettingStarted", className: "bp-support-page__comment-title"}, 
            React.createElement("strong", null, t('help_getting_started'), ":")
          ), 
          React.createElement("ol", {className: "bp-support-page__comment-text"}, 
            React.createElement("li", null, 
              t('help_getting_started_description_1')
            ), 
            React.createElement("li", null, 
              t('help_getting_started_description_part_2')
            )
          )
        ), 
        React.createElement("div", {className: "bp-support-page__comment"}, 
          React.createElement("h2", {ref: "tankAndSection", className: "bp-support-page__comment-title"}, 
            React.createElement("strong", null, t('help_assign_tanks_sections'))
          ), 
          React.createElement("ol", {className: "bp-support-page__comment-text"}, 
            React.createElement("li", null, 
              t('help_assign_tanks_sections_part_1')
            ), 
            React.createElement("li", null, 
              t('help_assign_tanks_sections_part_2')
            ), 
            React.createElement("li", null, 
              t('help_assign_tanks_sections_part_3')
            ), 
            React.createElement("li", null, 
              t('help_assign_tanks_sections_part_4')
            ), 
            React.createElement("li", null, 
              t('help_assign_tanks_sections_part_5')
            ), 
            React.createElement("li", null, 
              t('help_assign_tanks_sections_part_6')
            )
          )
        ), 
        React.createElement("div", {className: "bp-support-page__comment"}, 
          React.createElement("h2", {ref: "assignBeerStyle", className: "bp-support-page__comment-title"}, 
            React.createElement("strong", null, t('help_assign_beer_styles'))
          ), 
          React.createElement("ol", {className: "bp-support-page__comment-text"}, 
            React.createElement("li", null, 
              t('help_assign_beer_styles_description_part_1')
            ), 
            React.createElement("li", null, 
              t('help_assign_beer_styles_description_part_2')
            ), 
            React.createElement("li", null, 
              t('help_assign_beer_styles_description_part_3')
            ), 
            React.createElement("li", null, 
              t('help_assign_beer_styles_description_part_4')
            ), 
            React.createElement("li", null, 
              t('help_assign_beer_styles_description_part_5')
            ), 
            React.createElement("li", null, 
              t('help_assign_beer_styles_description_part_6')
            ), 
            React.createElement("li", null, 
              t('help_assign_beer_styles_description_part_7')
            ), 
            React.createElement("li", null, 
              t('help_assign_beer_styles_description_part_8')
            )
          )
        ), 
        React.createElement("div", {className: "bp-support-page__comment"}, 
          React.createElement("h2", {ref: "settingProcess", className: "bp-support-page__comment-title"}, 
            React.createElement("strong", null, t('help_setting_processes'))
          ), 
          React.createElement("ol", {className: "bp-support-page__comment-text"}, 
            React.createElement("li", null, t('help_setting_processes_description_part_1')), 
            React.createElement("li", null, t('help_setting_processes_description_part_2')), 
            React.createElement("li", null, t('help_setting_processes_description_part_3')), 
            React.createElement("li", null, t('help_setting_processes_description_part_4')), 
            React.createElement("li", null, t('help_setting_processes_description_part_5')), 
            React.createElement("li", null, t('help_setting_processes_description_part_6')), 
            React.createElement("li", null, t('help_setting_processes_description_part_7'))
          )
        ), 
        
        React.createElement("div", {className: "bp-support-page__comment"}, 
          React.createElement("h2", {ref: "scheduleBrew", className: "bp-support-page__comment-title"}, 
            React.createElement("strong", null, t('help_schedule_a_brew'))
          ), 
          React.createElement("ol", {className: "bp-support-page__comment-text"}, 
            React.createElement("li", null, t('help_schedule_a_brew_description_part_1')), 
            React.createElement("li", null, t('help_schedule_a_brew_description_part_2')), 
            React.createElement("li", null, t('help_schedule_a_brew_description_part_3')), 
            React.createElement("li", null, t('help_schedule_a_brew_description_part_4')), 
            React.createElement("li", null, t('help_schedule_a_brew_description_part_5')), 
            React.createElement("li", null, t('help_schedule_a_brew_description_part_6')), 
            React.createElement("li", null, t('help_schedule_a_brew_description_part_7')), 
            React.createElement("li", null, t('help_schedule_a_brew_description_part_8')), 
            React.createElement("li", null, t('help_schedule_a_brew_description_part_9')), 
            React.createElement("li", null, t('help_schedule_a_brew_description_part_10')), 
            React.createElement("li", null, t('help_schedule_a_brew_description_part_11')), 
            React.createElement("li", null, t('help_schedule_a_brew_description_part_12')), 
            React.createElement("li", null, t('help_schedule_a_brew_description_part_13')), 
            React.createElement("li", null, t('help_schedule_a_brew_description_part_14'))
          )
        ), 
        React.createElement("div", {className: "bp-support-page__comment"}, 
          React.createElement("h2", {ref: "batchNumber", className: "bp-support-page__comment-title"}, 
            React.createElement("strong", null, t('help_batch_numbers'))
          ), 
          React.createElement("ol", {className: "bp-support-page__comment-text"}, 
            React.createElement("li", null, t('help_batch_numbers_description_part_1')), 
            React.createElement("li", null, t('help_batch_numbers_description_part_2')), 
            React.createElement("li", null, t('help_batch_numbers_description_part_3')), 
            React.createElement("li", null, t('help_batch_numbers_description_part_4'))
          )
        ), 
        
        React.createElement("div", {className: "bp-support-page__comment"}, 
          React.createElement("h2", {ref: "scenarios", className: "bp-support-page__comment-title"}, 
            React.createElement("strong", null, t('help_possible_scenarios'))
          ), 
          React.createElement("ol", {className: "bp-support-page__comment-text"}, 
            React.createElement("li", null, t('help_possible_scenarios_description_part_1')), 
            React.createElement("li", null, t('help_possible_scenarios_description_part_2')), 
            React.createElement("li", null, t('help_possible_scenarios_description_part_3')), 
            React.createElement("li", null, t('help_possible_scenarios_description_part_4')), 
            React.createElement("li", null, t('help_possible_scenarios_description_part_5')), 
            React.createElement("li", null, t('help_possible_scenarios_description_part_6')), 
            React.createElement("li", null, t('help_possible_scenarios_description_part_7')), 
            React.createElement("li", null, t('help_possible_scenarios_description_part_8'))
          )
        ), 
        React.createElement("div", {className: "bp-support-page__comment"}, 
          React.createElement("h2", {ref: "iconLabelAndProcess", className: "bp-support-page__comment-title"}, 
            React.createElement("strong", null, t('help_icons_labels_processes'))
          ), 
          React.createElement("ol", {className: "bp-support-page__comment-text"}, 
            React.createElement("li", null, t('help_icons_labels_processes_description_part_1')), 
            React.createElement("li", null, t('help_icons_labels_processes_description_part_2')), 
            React.createElement("li", null, t('help_icons_labels_processes_description_part_3')), 
            React.createElement("li", null, t('help_icons_labels_processes_description_part_4')), 
            React.createElement("li", null, t('help_icons_labels_processes_description_part_5')), 
            React.createElement("li", null, t('help_icons_labels_processes_description_part_6')), 
            React.createElement("li", null, t('help_icons_labels_processes_description_part_7')), 
            React.createElement("li", null, t('help_icons_labels_processes_description_part_8'))
          )
        ), 
        React.createElement("div", {className: "bp-support-page__comment"}, 
          React.createElement("h2", {ref: "notes", className: "bp-support-page__comment-title"}, 
            React.createElement("strong", null, t('help_notes_title'))
          ), 
          React.createElement("ol", {className: "bp-support-page__comment-text"}, 
            React.createElement("li", null, t('help_notes_description_part_1')), 
            React.createElement("li", null, t('help_notes_description_part_2'))
          )
        ), 
        React.createElement("div", {className: "bp-support-page__comment"}, 
          React.createElement("h2", {ref: "messages", className: "bp-support-page__comment-title"}, 
            React.createElement("strong", null, t('help_messages_title'))
          ), 
          React.createElement("p", {className: "bp-support-page__comment-text"}, 
            t('help_messages_description')
          )
        ), 
        React.createElement("div", {className: "bp-support-page__comment"}, 
          React.createElement("h2", {ref: "changeOrder", className: "bp-support-page__comment-title"}, 
            React.createElement("strong", null, t('help_make_changes_to_an_order'))
          ), 
          React.createElement("ol", {className: "bp-support-page__comment-text"}, 
            React.createElement("li", null, t('help_make_changes_to_an_orde_description_part_1')), 
            React.createElement("li", null, 
              t('help_make_changes_to_an_orde_description_part_2')
            ), 
            React.createElement("li", null, 
              t('help_make_changes_to_an_orde_description_part_3')
            ), 
            React.createElement("li", null, 
              t('help_make_changes_to_an_orde_description_part_4')
            ), 
            React.createElement("li", null, 
              t('help_make_changes_to_an_orde_description_part_5')
            ), 
            React.createElement("li", null, 
              t('help_make_changes_to_an_orde_description_part_6')
            ), 
            React.createElement("li", null, 
              t('help_make_changes_to_an_orde_description_part_7'), 
              React.createElement("br", null), 
              t('help_make_changes_to_an_orde_description_part_8'), 
              React.createElement("br", null), 
              t('help_make_changes_to_an_orde_description_part_9'), 
              React.createElement("br", null), 
              t('help_make_changes_to_an_orde_description_part_10'), 
              React.createElement("br", null), 
              t('help_make_changes_to_an_orde_description_part_11'), 
              React.createElement("br", null), 
              t('help_make_changes_to_an_orde_description_part_12'), 
              React.createElement("br", null), 
              t('help_make_changes_to_an_orde_description_part_13'), 
              React.createElement("br", null), 
              t('help_make_changes_to_an_orde_description_part_14'), 
              React.createElement("br", null), 
              t('help_make_changes_to_an_orde_description_part_15'), 
              React.createElement("br", null)
            )
          )
        ), 
        React.createElement("div", {className: "bp-support-page__comment"}, 
          React.createElement("h2", {ref: "display", className: "bp-support-page__comment-title"}, 
            React.createElement("strong", null, t('help_display_title'))
          ), 
          React.createElement("p", {className: "bp-support-page__comment-text"}, 
            t('help_display_description')
          )
        ), 
        React.createElement("br", null), 
        React.createElement("div", {className: "bp-support-page__comment"}, 
          React.createElement("h2", {ref: "publish", className: "bp-support-page__comment-title"}, 
            React.createElement("strong", null, t('help_publish_title'))
          ), 
          React.createElement("p", {className: "bp-support-page__comment-text"}, t('help_publish_description_part_1')), 
          React.createElement("p", {className: "bp-support-page__comment-text"}, t('help_publish_description_part_2'), React.createElement("a", {
            href: "mailto:support@brewplanner.com?Subject=Need%20help", 
            target: "_top"}, "support@brewplanner.com"), "."
          )
        ), 
        React.createElement("div", {className: "bp-support-page__footer"}, 
          React.createElement("hr", null), 
          React.createElement("div", {className: "bp-support-page__footer-signature"}, 
            t('thank_you'), React.createElement("br", null), 
            t('confirm_new_password_static_page_greeting'), React.createElement("br", null), 
            React.createElement("small", null, 
              React.createElement("a", {href: "http://www.brewplanner.com", 
                 target: "_top"}, "www.Brewplanner.com")
            )
          ), 
          React.createElement("hr", {className: "bp-support-page__footer-separator"}), 
          React.createElement("div", {className: "bp-support-page__footer-legal"}, "Copyright © ", moment().format('YYYY'), " Brewplanner" + ' ' +
            "LLC.", 
            React.createElement("i", {className: "bp-support-page__footer-legal-version"}, `v${packageJson.version}`)
          ), 
          React.createElement("br", null)
        )
      )
    );
  }
});

module.exports = Help;



/** WEBPACK FOOTER **
 ** ./src/views/Help/Help.jsx
 **/